<mat-card class="duallist-card">
  <mat-card-header>
    <mat-card-title color="primary">{{ listLabel }}</mat-card-title>
  </mat-card-header>
  <div class="dual-list">
    <div
      class="listbox"
      [ngStyle]="{
        order: direction() ? 1 : 2,
        'margin-left': direction() ? 0 : '10px'
      }"
    >

      <button
        mat-raised-button
        color="primary"
        name="addBtn"
        class="btn-block"
        (click)="moveItemToConfirmed()"
        [ngClass]="direction() ? 'point-right' : 'point-left'"
        [disabled]="available.pick.length === 0"
      >
        <mat-icon>{{ direction() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        <span>{{ format.add }}</span>
      </button>

      <form *ngIf="filter" class="filter">
        <mat-form-field appearance="legacy" style="width: 100%">
          <input
            matInput
            class="form-control"
            name="filterSource"
            [(ngModel)]="available.picker"
            (ngModelChange)="onFilter(available)"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </form>

      <div class="record-picker">
        <ul
          [ngStyle]="{ 'max-height': height, 'min-height': '300px' }"
          [ngClass]="{ over: available.dragOver }"
          (drop)="drop($event, confirmed); emitMovedCentro.emit()"
          (dragover)="allowDrop($event, available)"
          (dragleave)="dragLeave()"
        >
          <li
            *ngFor="let item of available.sift; let idx = index"
            (click)="
              disabled ? null : onItemSelectedFromAvailable(item);
              shiftClick($event, idx, available, item)
            "
            [ngClass]="{
              selected: isItemSelected(available.pick, item),
              disabled: disabled
            }"
            [draggable]="!disabled && format.draggable"
            (dragstart)="drag($event, item, available)"
            (dragend)="dragEnd(available)"
          >
            <label>{{ item._name }}</label>
          </li>
        </ul>
      </div>

      <!-- Add pagination -->
      <div *ngIf="withPagination" class="paginator">
        <mat-paginator
          [length]="totalLength"
          [pageSize]="paginator.pagelements"
          [pageSizeOptions]="[5, 10, 20, 50, 100]"
          (page)="emitPageEvent($event)"
        ></mat-paginator>
      </div>

      <div class="button-bar">
        <button
          mat-raised-button
          color="accent"
          class="pull-left"
          (click)="selectAll(available)"
          [disabled]="disabled || isAllSelected(available)"
        >
          {{ format.all }}
        </button>
        <button
          mat-raised-button
          color="accent"
          class="pull-right"
          (click)="selectNone(available)"
          [disabled]="!isAnySelected(available)"
        >
          {{ format.none }}
        </button>
      </div>

      
    </div>

    <div
      class="listbox"
      [ngStyle]="{
        order: direction() ? 2 : 1,
        'margin-left': direction() ? '10px' : 0
      }"
    >

      <button
        mat-raised-button
        color="primary"
        name="removeBtn"
        class="btn-block"
        (click)="moveItemFromConfirmed()"
        [ngClass]="direction() ? 'point-left' : 'point-right'"
        [disabled]="confirmed.pick.length === 0"
      >
        <mat-icon>{{ direction() ? 'chevron_left' : 'chevron_right' }}</mat-icon>
        <span>{{ format.remove }}</span>
      </button>

      <form *ngIf="filter" class="filter">
        <mat-form-field appearance="legacy" style="width: 100%">
          <input
            matInput
            class="form-control"
            name="filterDestination"
            [(ngModel)]="confirmed.picker"
            (ngModelChange)="onFilter(confirmed)"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </form>

      <div class="record-picker">
        <ul
          [ngStyle]="{ 'max-height': height, 'min-height': '300px' }"
          [ngClass]="{ over: confirmed.dragOver }"
          (drop)="drop($event, available); emitMovedCentro.emit()"
          (dragover)="allowDrop($event, confirmed)"
          (dragleave)="dragLeave()"
        >
          <li
            #itmConf
            *ngFor="let item of confirmed.sift; let idx = index"
            (click)="
              disabled ? null : onItemSelectedFromConfirmed(item, $event, idx);
              shiftClick($event, idx, confirmed, item)
            "
            [ngClass]="{
              selected: isItemSelected(confirmed.pick, item),
              disabled: disabled,
              'drag-item': format.draggable
            }"
            [draggable]="!disabled && format.draggable"
            (dragstart)="onDragStartConfirmed($event, idx)"
            (dragover)="allowDrop($event, confirmed)"
            (drop)="onDropConfirmed($event, idx)"
            (dragend)="onDragEndConfirmed(confirmed, $event)"
          >
            <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="8px">
              <mat-icon class="drag-handle" *ngIf="format.draggable">drag_indicator</mat-icon>
              <label fxFlex>{{ item._name }}</label>
            </div>
          </li>
        </ul>
      </div>

      <!-- Panel de edición cuando se selecciona un elemento -->
      <div *ngIf="element && element.idx !== undefined && element.idx !== -1" class="edit-panel mt-3">
        <mat-card class="edit-card">
          <mat-card-header>
            <mat-card-title>
              <mat-icon class="mr-2">edit</mat-icon>
              {{element.idx + 1}}-{{ element.name }}
              <span class="element-name" *ngFor="let p of element.properties">
                <span *ngIf="p.name=='name'">({{p.value}})</span>
              </span>
              <mat-icon *ngIf="hasUnsavedChanges" class="unsaved-indicator" color="warn" [matTooltip]="'CambiosSinGuardar' | translate">circle</mat-icon>
            </mat-card-title>
          </mat-card-header>
          
          <mat-card-content>
            <div [formGroup]="myGroup" class="form-group text-left">
              <mat-accordion>
                <!-- Propiedades Básicas -->
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="mr-2">settings</mat-icon>
                      {{ "PropiedadesBasicas" | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div *ngFor="let property of element?.properties; let idx = index">
                    <ng-container *ngIf="['name', 'label', 'visible', 'required'].includes(property.name)">
                      <ng-container [ngSwitch]="property.type">
                        <ng-container *ngSwitchCase="'string'">
                          <app-input-html-element 
                            name="{{property.name}}" idx="{{idx}}" value="{{property.value}}" (changed)="onPropertyChanged($event)">
                          </app-input-html-element>
                        </ng-container>
                        <ng-container *ngSwitchCase="'boolean'">
                          <app-toggle-html-element 
                            name="{{property.name}}" idx="{{idx}}" value="{{property.value}}" (changed)="onPropertyChanged($event)">
                          </app-toggle-html-element>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>

                <!-- Opciones/Configuración -->
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="mr-2">list</mat-icon>
                      {{ "OpcionesYConfiguracion" | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div *ngFor="let property of element?.properties; let idx = index">
                    <ng-container *ngIf="['optionsJSON'].includes(property.name)">
                      <ng-container [ngSwitch]="property.type">
                        <ng-container *ngSwitchCase="'array'">
                          <app-array-html-element 
                            name="{{property.name}}" idx="{{idx}}" [value]="property.value" (changed)="onPropertyChanged($event)">
                          </app-array-html-element>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>

                <!-- Otras Propiedades -->
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="mr-2">tune</mat-icon>
                      {{ "OtrasPropiedades" | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div *ngFor="let property of element?.properties; let idx = index">
                    <ng-container *ngIf="!['name', 'label', 'visible', 'required', 'options', 'optionsJSON'].includes(property.name)">
                      <ng-container [ngSwitch]="property.type">
                        <ng-container *ngSwitchCase="'string'">
                          <app-input-html-element 
                            name="{{property.name}}" idx="{{idx}}" value="{{property.value}}" (changed)="onPropertyChanged($event)">
                          </app-input-html-element>
                        </ng-container>
                        <ng-container *ngSwitchCase="'boolean'">
                          <app-toggle-html-element 
                            name="{{property.name}}" idx="{{idx}}" value="{{property.value}}" (changed)="onPropertyChanged($event)">
                          </app-toggle-html-element>
                        </ng-container>
                        <ng-container *ngSwitchCase="'array'">
                          <app-array-html-element 
                            name="{{property.name}}" idx="{{idx}}" [value]="property.value" (changed)="onPropertyChanged($event)">
                          </app-array-html-element>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-card-content>
          
          <mat-card-actions align="end">
            <button mat-button (click)="cancelChanges()" [disabled]="!hasUnsavedChanges">
              <mat-icon>close</mat-icon>
              {{ "Cancelar" | translate }}
            </button>
            <button mat-raised-button color="primary" (click)="saveChanges()" [disabled]="!hasUnsavedChanges">
              <mat-icon>save</mat-icon>
              {{ "Guardar" | translate }}
            </button>
          </mat-card-actions>
        </mat-card>
      </div>

      <div class="button-bar">
        <button
          mat-raised-button
          color="accent"
          class="pull-left"
          (click)="selectAll(confirmed)"
          [disabled]="disabled || isAllSelected(confirmed)"
        >
          {{ format.all }}
        </button>
        <button
          mat-raised-button
          color="accent"
          class="pull-right"
          (click)="selectNoneConfirmed()"
          [disabled]="!isAnySelected(confirmed)"
        >
          {{ format.none }}
        </button>
      </div>

    </div>
  </div>
</mat-card>
